/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Direct_Feature_ConfirmationInputs */

const en_home_direct_feature_confirmation = /** @type {(inputs: Home_Direct_Feature_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant confirmation`)
};

/**
* | output |
* | --- |
* | "Instant confirmation" |
*
* @param {Home_Direct_Feature_ConfirmationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_direct_feature_confirmation = /** @type {((inputs?: Home_Direct_Feature_ConfirmationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Direct_Feature_ConfirmationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_direct_feature_confirmation(inputs)
});